import { CreateEnterpriseDepartmentRequestDTO, EnterpriseDepartmentResponseDTO } from 'typings/dto/enterpriseDepartment';
import ModelActionsService from '../ModelActionsService';
import IDepartmentActionsService from './IDepartmentActionsService';
import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import NavigateBackendUtils from '../../../utils/NavigateBackend';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class DepartmentActionsServiceImpl
  extends ModelActionsService<EnterpriseDepartment, CreateEnterpriseDepartmentRequestDTO, EnterpriseDepartmentResponseDTO>
  implements IDepartmentActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const url = PATH_BACKEND.enterpriseDepartment.orderFilter;
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };

  public getAllUnPaged(tenantId: string): Promise<Array<EnterpriseDepartmentResponseDTO>> {
    const url = NavigateBackendUtils.addParamsToExistedUrl(PATH_BACKEND.enterpriseDepartment.unPaged, { tenantId: tenantId });
    return this.entityApiService.getWithCredentials(url);
  }
}
